import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginInfo() {
    const [show, setShow] = useState(true);
    const navigate = useNavigate();

    function handleClick() {
        setShow(false);
        navigate("/login");
    }
    return (
        <Modal backdrop="static" show={show} >
            <Modal.Body>
                Du bist noch nicht angemeldet. Um ein Poem zu melden, musst Du dich vorher einloggen.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClick}>
                    Weiter
                </Button>
            </Modal.Footer>
        </Modal>
    )
}